import React, { useState, useEffect } from 'react'
import CardTitle from 'src/components/sharedComponents/CardTitle'
import { makeStyles } from '@material-ui/core/styles'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import AccordionMenu from 'src/components/reports/reportsBoard/AccordionMenu'
import { TabPanel , a11yProps } from 'src/components/sharedComponents/TapPanel/index'
import useLocalStorage from 'src/utils/hooks/useLocalStorage'
import * as menu from '../../../container/ReportsContainer/ReportsBoardContainer/menu'

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    height: '100%',
    '& a': {
      color: '#1B1B1B',
    },
    '& a:active ': {
      color: 'red',
    },
    '& a:hover  ': {
      color: '#FFA500',
    },
  },
  menu: { minWidth: '100%' },
  tabs: {
    borderRight: `1px solid #1b1b1b`,
    display: 'flex',
    minWidth: '250px',
  },
  indicator: {
    background: '#FFA500',
  },
}))

const ReportBoard = () => {
  const classes = useStyles()
  const [itemIndex, setItemIndex] = useLocalStorage('itemIndex', 0)
  const [value, setValue] = useState(itemIndex || 0)

  const handleChange = (event, newValue) => {
    setValue(newValue)
    setItemIndex(newValue)
  }

  useEffect(() => {
    setValue(itemIndex)
  }, [itemIndex])
  return (
    <>
      <CardTitle title="Informe Junta Directiva" />

      <div className={classes.root}>
        <Tabs
          classes={{
            indicator: classes.indicator,
          }}
          orientation="vertical"
          scrollButtons="auto"
          selectionFollowsFocus
          variant="scrollable"
          value={value}
          onChange={handleChange}
          aria-label="taps"
          className={classes.tabs}
        >
          <Tab label="Comercial" {...a11yProps(0)} />
          <Tab label="Movilidad Eléctrica" {...a11yProps(1)} />
          <Tab label="Repuestos y Accesorios" {...a11yProps(2)} />
          <Tab label="Carpa" {...a11yProps(3)} />
          <Tab label="Operaciones" {...a11yProps(4)} />
          <Tab label="Financiera" {...a11yProps(5)} />
          <Tab label="Talento Humano" {...a11yProps(6)} />
          <Tab label="Servicio Posventa" {...a11yProps(7)} />
          <Tab label="Desarrollo de Negocio" {...a11yProps(8)} />
          <Tab label="Customer Experience" {...a11yProps(9)} />
        </Tabs>
        <div id="roor" className={classes.root}>
          <TabPanel
            className={classes.menu}
            id="tabpanel"
            value={value}
            index={0}
          >
            <AccordionMenu menu={menu.MENU_COMERCIAL} />
          </TabPanel>
          <TabPanel className={classes.menu} value={value} index={1}>
            <AccordionMenu menu={menu.MOVILIDAD_ELECTRICA} />
          </TabPanel>
          <TabPanel className={classes.menu} value={value} index={2}>
            <AccordionMenu menu={menu.REPUESTOS_ACCESORIOS} />
          </TabPanel>
          <TabPanel className={classes.menu} value={value} index={3}>
            <AccordionMenu menu={menu.CARPA} />
          </TabPanel>
          <TabPanel className={classes.menu} value={value} index={4}>
            <AccordionMenu menu={menu.OPERACIONES} />
          </TabPanel>
          <TabPanel className={classes.menu} value={value} index={5}>
            <AccordionMenu menu={menu.FINANCIERA} />
          </TabPanel>
          <TabPanel className={classes.menu} value={value} index={6}>
            <AccordionMenu menu={menu.TALENTO} />
          </TabPanel>
          <TabPanel className={classes.menu} value={value} index={7}>
            <AccordionMenu menu={menu.POSVENTA} />
          </TabPanel>
          <TabPanel className={classes.menu} value={value} index={8}>
            <AccordionMenu menu={menu.DESARROLLO} />
          </TabPanel>
          <TabPanel className={classes.menu} value={value} index={9}>
            <AccordionMenu menu={menu.CUSTOMERS} />
          </TabPanel>
        </div>
      </div>
    </>
  )
}

export default ReportBoard
